import React from "react";
import { Query } from "../../@Utils/AdmediaryApi";
import { Loader, Schema, Form } from "rsuite";
import Field from "../Field";
import SelectPicker from "rsuite/lib/SelectPicker";

const { StringType, NumberType } = Schema.Types;

const model = Schema.Model({
  field_id: NumberType(),
  contract_id: NumberType().isRequired("Contract ID is required."),
  is_get: NumberType().isRequired("Method is required."),
  parameter: StringType().isRequired("Field Value is required."),
  field: StringType(),
});

type BuyerContractFieldFormType = {
  fieldId?: number;
  contractId?: number;
  formRef?: React.MutableRefObject<any>;
  parentCallback?: any;
};

const BuyerContractFieldForm: React.FC<BuyerContractFieldFormType> = ({
  fieldId = 0,
  contractId = 0,
  formRef = null,
  parentCallback = () => {},
}) => {
  formRef = formRef || React.createRef();
  const [isLoading, setIsLoading] = React.useState(false);
  const emptyItem = {
    field_id: 0,
    contract_id: contractId,
  };
  const [formValue, setFormValue] = React.useState(emptyItem);
  const [formError, setFormError] = React.useState({});

  const params = {
    field_id: fieldId,
  };

  const fetchData = React.useCallback(async () => {
    const setData = (data: any) =>
      handleChange(prepareFormData(Array.isArray(data) ? data[0] : data));

    if (params.field_id === 0) {
      setData(emptyItem);
      return;
    }

    try {
      setIsLoading(true);
      const results: any = await Query("buyer_contract_field", params);
      setData(results.data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    } finally {
      // setIsLoading(false);
    }
  }, []);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const prepareFormData = (record: any) => {
    if (record === null) {
      return;
    }

    return record;
  };

  const handleChange = (data: any) => {
    setFormValue(data);

    if (parentCallback instanceof Function) {
      parentCallback(data);
    }
  };

  if (isLoading || formValue === null) {
    return <Loader center size="lg" content="Loading..." />;
  }

  return (
    <Form
      ref={formRef}
      onChange={handleChange}
      onCheck={setFormError}
      model={model}
      layout="horizontal"
      formValue={formValue}
      formError={formError}
    >
      <Field
        label="Method"
        name="is_get"
        placeholder="Select Method"
        accepter={SelectPicker}
        searchable={false}
        cleanable={false}
        data={[
          { value: 1, label: "GET" },
          { value: 0, label: "POST" },
        ]}
      />
      <Field label="Field Name" name="parameter" />
      <Field label="Field Value" name="field" />
      {/*<span>{JSON.stringify(formValue)}</span>*/}
    </Form>
  );
};

export default BuyerContractFieldForm;
